import { SelectionHandler } from "../../types";
import { HometrackComparableSelectionDetailView } from "./HometrackComparableSelectionDetailView";
import { LandTechComparableSelectionDetailView } from "./LandTechComparableSelectionDetailView";
import { ComparableSelectionHeader } from "./ComparableSelectionHeader";
import { ComparablesSelectionTitle } from "./ComparablesSelectionTitle";
import { ComparablesSelectionMapLayer } from "./ComparablesSelectionMapLayer";

export const LandTechComparableSelectionHandler: SelectionHandler = {
  SelectionTitle: ComparablesSelectionTitle,
  SelectionHeader: ComparableSelectionHeader,
  SelectionDetailView: LandTechComparableSelectionDetailView,
  SelectionMapLayer: ComparablesSelectionMapLayer,
};

export const HometrackComparableSelectionHandler: SelectionHandler = {
  SelectionTitle: ComparablesSelectionTitle,
  SelectionHeader: ComparableSelectionHeader,
  SelectionDetailView: HometrackComparableSelectionDetailView,
  SelectionMapLayer: ComparablesSelectionMapLayer,
};
